import { render, staticRenderFns } from "./DocumentMainView.vue?vue&type=template&id=d3bba1c0&scoped=true&"
import script from "./DocumentMainView.vue?vue&type=script&lang=js&"
export * from "./DocumentMainView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMainView.vue?vue&type=style&index=0&id=d3bba1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bba1c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3bba1c0')) {
      api.createRecord('d3bba1c0', component.options)
    } else {
      api.reload('d3bba1c0', component.options)
    }
    module.hot.accept("./DocumentMainView.vue?vue&type=template&id=d3bba1c0&scoped=true&", function () {
      api.rerender('d3bba1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/DocumentMainView.vue"
export default component.exports